import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../_common/application/ts/Glob';
import { ParameterField } from '../../../_common/platform/tsx/ParameterField';
import SelectField from '../../../_common/platform/ts/SelectField';
import NumberField from '../../../_common/platform/ts/NumberField';
import { validators } from '../../../_common/platform/ts/validators';

export enum IActionType {
    print = 0,
    exportToPdf,
    copyToClipboard
}
const MAXRECORD = 1000;
export class PdfParamDialog extends React.Component<
    {
        setConfirmValueGetter(getConfirmValue);
        unsetConfirmValueGetter?();

        glob: IGlob;
        options: {
            papersize: string;
            layout: 'p' | 'portrait' | 'l' | 'landscape';
            limit: number;
            showLimit: true;
            showPageSize: true;
            showLayout: true;
            actionType;
            maxRecords: number;
        };
    },
    any
> {
    constructor(props) {
        super(props);

        let maxRecords = props.options.maxRecords || MAXRECORD;
        maxRecords = maxRecords > MAXRECORD ? MAXRECORD : maxRecords;
        this.state = {
            layout: new SelectField(props.glob, 'Layout', [], 'p', {
                values: ['p', 'l'],
                display: ['Portrait', 'Landscape']
            }),
            papersize: new SelectField(props.glob, 'Paper Size', [], 'A4', {
                values: ['Legal', 'Letter', 'Tabloid', 'A0', 'A1', 'A2', 'A3', 'A4', 'A5'],
                display: ['Legal', 'Letter', 'Tabloid', 'A0', 'A1', 'A2', 'A3', 'A4', 'A5']
            }),
            limit: new NumberField(
                props.glob,
                'Limit for number of Rows (1-' + maxRecords + ')',
                [
                    validators.number.shouldBe,
                    validators.number.integer,
                    validators.number.not_negative,
                    validators.number.range(1, maxRecords)
                ],
                maxRecords,
                {
                    min: 1,
                    max: maxRecords,
                    allowNull: false,
                    applyOnEnter: true,
                    integer: true
                }
            ),
            value: {
                papersize: props.options.papersize,
                layout: props.options.layout.length > 0 ? props.options.layout[0] : props.options.layout,
                limit: props.options.limit > maxRecords ? maxRecords : props.options.limit
            }
        };
    }

    private getConfirmValue = () => {
        return this.state.value;
    };

    componentWillMount() {
        var obj = this.props.setConfirmValueGetter(this.getConfirmValue);
    }

    componentWillUnmount() {
        if (typeof this.props.unsetConfirmValueGetter === 'function') {
            this.props.unsetConfirmValueGetter();
        }
    }

    getChangeHandler = (name) => {
        var self = this;

        return function (value) {
            /* const pattern = /^([1-9][0-9]{0,2}|1000)$/;
            const regEx = new RegExp(pattern);
            if (!regEx.test(value)) {
                value = 1000;
            }*/
            var settings = _.clone(self.state.value);

            settings[name] = value;

            self.setState({
                value: settings
            });
            var storageKey = 'print-settings';
            var storage = JSON.parse(self.props.glob.AppStore.getFromLocalStorage(storageKey)) || {};

            if (self.props.options.actionType === IActionType.exportToPdf) {
                storage.pdflimit = settings;
            }
            if (self.props.options.actionType === IActionType.print) {
                storage.printlimit = settings;
            }

            if (storage) {
                self.props.glob.AppStore.saveToLocalStorage(storageKey, JSON.stringify(storage));
            }
        };
    };

    private _getPaperSize = () => {
        var EditComponent = this.state.papersize.constructor.EditComponent;

        return (
            <ParameterField label={'Paper Size'} options={this.state.papersize.options}>
                <EditComponent
                    glob={this.props.glob}
                    value={this.state.value.papersize}
                    options={this.state.papersize.options}
                    onChange={this.getChangeHandler('papersize')}
                />
            </ParameterField>
        );
    };

    private _getLayout = () => {
        var EditComponent = this.state.layout.constructor.EditComponent;

        return (
            <ParameterField label={'Layout'} options={this.state.layout.options}>
                <EditComponent
                    glob={this.props.glob}
                    value={this.state.value.layout}
                    options={this.state.layout.options}
                    onChange={this.getChangeHandler('layout')}
                />
            </ParameterField>
        );
    };

    private _getLimit = () => {
        var EditComponent = this.state.limit.constructor.EditComponent;
        let maxRecords = this.props.options.maxRecords || MAXRECORD;
        maxRecords = maxRecords > MAXRECORD ? MAXRECORD : maxRecords;
        return (
            <ParameterField label={'Limit for number of Rows (1-' + maxRecords + ')'} options={this.state.limit}>
                <EditComponent
                    glob={this.props.glob}
                    value={this.state.value.limit}
                    options={this.state.limit.options}
                    onChange={this.getChangeHandler('limit')}
                />
            </ParameterField>
        );
    };

    render() {
        let paperSize: React.JSX.Element = this._getPaperSize();
        let layout: React.JSX.Element = this._getLayout();
        let limit: React.JSX.Element = this._getLimit();
        return (
            <div className="export-params">
                {this.props.options.showPageSize ? paperSize : null}
                {this.props.options.showLayout ? layout : null}
                {this.props.options.showLimit ? limit : null}
            </div>
        );
    }
}
